import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useImpactClaims } from 'hooks';
import { ImpactClaimDocumentsList } from 'components/Shared/ImpactClaims';
import { Breadcrumbs, Loader } from 'components/Shared';
import { Col, Row } from 'styled-bootstrap-grid';
import { ChevronLeft } from '@styled-icons/bootstrap/ChevronLeft';
import dynamic from 'next/dynamic';
import { ProductJourneyPages } from 'components/Shared/ProductJourney/pages';
import { useStackableBreadcrumbs } from 'components/Shared/StackedContent/StackableContentContext';
const DocumentViewer = dynamic(() => import('components/Desktop/DocumentViewer'), {
    loading: () => React.createElement(Loader, null), // eslint-disable-line react/display-name
    ssr: false,
});
const Container = styled.div `
  margin: 0 0;
  overflow: hidden;
`;
const DocumentListContainer = styled.div `
  padding: 30px 0;
`;
const DocumentsList = styled.div `
  padding: 30px;
`;
const BackButton = styled.button `
  background: transparent;
  font-size: 14px;
  border: none;
  padding: 5px 20px;
  display: flex;
  align-items: center;
  grid-gap: 5px;
  cursor: pointer;
`;
const ImpactClaimDocumentSelection = ({ goBack, initialDocumentIndex = 0, impactClaim, renderOnProductJourney = false, }) => {
    var _a;
    const { selectedClaim } = useImpactClaims();
    const [activeDocumentIndex, setActiveDocumentIndex] = useState(initialDocumentIndex);
    const activeClaim = renderOnProductJourney ? impactClaim : selectedClaim;
    const activeDocument = (_a = activeClaim === null || activeClaim === void 0 ? void 0 : activeClaim.attachments) === null || _a === void 0 ? void 0 : _a.edges[activeDocumentIndex];
    const { t } = useTranslation();
    const breadcrumbs = useStackableBreadcrumbs();
    const documentContainerRef = useRef(null);
    const scrollToPdfViewer = () => {
        var _a;
        (_a = documentContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
        });
    };
    useEffect(scrollToPdfViewer, [activeDocumentIndex]);
    const defaultBreadcrumbs = [
        {
            title: selectedClaim === null || selectedClaim === void 0 ? void 0 : selectedClaim.impactCatalogItem.title,
            action: () => goBack(),
        },
        {
            title: t('impact-claims.documents'),
            action: () => null,
        },
    ];
    return (React.createElement("div", { ref: documentContainerRef },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { md: 5, xxl: 4 },
                    React.createElement(DocumentListContainer, null,
                        React.createElement(BackButton, { onClick: goBack },
                            React.createElement(ChevronLeft, { size: 13 }),
                            t('impact-claims.back-to-overview')),
                        React.createElement(Breadcrumbs, { config: renderOnProductJourney ? breadcrumbs : defaultBreadcrumbs, backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY }, showFullCrumbs: true }),
                        React.createElement(DocumentsList, null,
                            React.createElement(ImpactClaimDocumentsList, { attachments: activeClaim === null || activeClaim === void 0 ? void 0 : activeClaim.attachments.edges, goToDocument: setActiveDocumentIndex, activeDocumentIndex: activeDocumentIndex })))),
                React.createElement(Col, { md: 7, xxl: 8 }, activeDocument.node.visibility === 'PUBLIC' &&
                    (activeDocument === null || activeDocument === void 0 ? void 0 : activeDocument.node.url) && (React.createElement(DocumentViewer, { file: activeDocument === null || activeDocument === void 0 ? void 0 : activeDocument.node.url })))))));
};
export default ImpactClaimDocumentSelection;
